/**
 * WizardIssuesContext — OPEN correction issues available to the wizard steps
 * (PR-ONB-PRECHECK-3).
 *
 * Populated by the RegistrationLayout from the resume stash (the area "Dati"
 * page fetched them with the draft). Empty for plain DRAFT sessions and for
 * the anonymous/legacy flow — the per-step banner renders nothing then.
 */

import { createContext, useContext } from 'react';
import type { AreaOpenIssue } from '@/lib/areaApi';

const WizardIssuesContext = createContext<readonly AreaOpenIssue[]>([]);

export const WizardIssuesProvider = WizardIssuesContext.Provider;

export function useWizardIssues(): readonly AreaOpenIssue[] {
  return useContext(WizardIssuesContext);
}
